const UPSELL_TRIGGER_TAG = 'funko';
const UPSELL_HANDLE = 'funko-pop-protector-foldable';

async function checkUpsell() {
  console.log('checkUpsell fired');
  const banner = document.getElementById('cart-upsell-banner');
  if (!banner) return;

  const cart = await fetch('/cart.js').then(r => r.json());
  console.log('cart items:', cart.items.map(i => i.handle));

  const alreadyInCart = cart.items.some(i => i.handle === UPSELL_HANDLE);
  if (alreadyInCart) { banner.style.display = 'none'; return; }

  let hasTrigger = false;
  for (const item of cart.items) {
    const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
    console.log(item.handle, 'tags:', product.tags);
    if (product.tags && product.tags.includes(UPSELL_TRIGGER_TAG)) {
      hasTrigger = true;
      break;
    }
  }

  console.log('hasTrigger:', hasTrigger);
  if (!hasTrigger) { banner.style.display = 'none'; return; }

  const upsell = await fetch(`/products/${UPSELL_HANDLE}.js`).then(r => r.json());
  const variant = upsell.variants[0];

  document.getElementById('cart-upsell-image').src = upsell.featured_image;
  document.getElementById('cart-upsell-title').textContent = upsell.title;
  document.getElementById('cart-upsell-price').textContent = (variant.price / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
  document.getElementById('cart-upsell-btn').dataset.variantId = variant.id;

  banner.style.display = 'flex';
}

// Run on page load
checkUpsell();

// Re-run when cart drawer opens or updates
document.addEventListener('cart:refresh', checkUpsell);
document.addEventListener('cart-drawer:open', checkUpsell);

// Watch for cart drawer opening via DOM changes
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer) {
  const drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('active') ||
          !mutation.target.classList.contains('drawer') ||
          mutation.target.style.visibility === 'visible') {
        checkUpsell();
      }
    });
  });
  drawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });
}

// One-click add
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('#cart-upsell-btn');
  if (!btn) return;

  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
    });

    // Fetch fresh cart drawer HTML via section rendering API
    const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const sections = await sectionsRes.json();

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.renderContents({ sections });
    } else {
      window.location.reload();
    }

  } catch(err) {
    console.error('Upsell error:', err);
    btn.disabled = false;
    btn.textContent = 'Add';
  }
});